import { useEffect, useState } from 'react';
import { useApi } from 'api/api-context';
import { DeviceListEvidenceFieldSectionsResponse } from 'api/actions/device-list-evidence-field-sections/device-list-evidence-field-sections-response';

export type EvidenceSection = DeviceListEvidenceFieldSectionsResponse[number];

/** Loads the shared layout catalog without accepting stale responses after unmount. */
export default function useEvidenceSections() {
  const { getAction } = useApi();
  const [sections, setSections] = useState<EvidenceSection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    let current = true;
    getAction('DeviceListEvidenceFieldSections')({})
      .then((response) => {
        if (current) setSections(response);
      })
      .catch(() => {
        if (current) setError(true);
      })
      .finally(() => {
        if (current) setLoading(false);
      });
    return () => {
      current = false;
    };
  }, [getAction]);
  return { sections, loading, error };
}
